import React from 'react'
import { includedItemOptions, OTHER_ID } from './includedItems.js'

/**
 * The included-items step, shared by Testing and Manual listing (W7).
 * Required: the parent keeps Continue / Done disabled until
 * includedItemsAnswered() is true. Both screens keep their own theme and Card,
 * so the parent passes the theme and wraps this in its Card.
 */
export default function IncludedItemsPicker({ theme, options, selected, otherText, onToggle, onOtherChange }) {
  const choices = includedItemOptions(options)
  const ticked = selected || []

  return (
    <>
      <div style={{ fontWeight: 600, marginBottom: '4px' }}>Included items</div>
      <div style={{ fontSize: '13px', color: theme.colors.grey500, marginBottom: '12px' }}>
        Required. Tick everything that came with it, or Nothing else included.
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: ticked.includes(OTHER_ID) ? '12px' : 0 }}>
        {choices.map(choice => {
          const isTicked = ticked.includes(choice.id)
          return (
            <button
              key={choice.id}
              type="button"
              aria-pressed={isTicked}
              onClick={() => onToggle(choice.id)}
              style={{
                padding: '8px 14px',
                border: `2px solid ${isTicked ? theme.colors.greenOnions : theme.colors.grey200}`,
                borderRadius: theme.radius.md,
                background: isTicked ? theme.colors.greenLight : theme.colors.white,
                fontWeight: isTicked ? 600 : 400,
                fontSize: '13px',
                cursor: 'pointer'
              }}
            >
              {isTicked && '✓ '}{choice.label}
            </button>
          )
        })}
      </div>
      {ticked.includes(OTHER_ID) && (
        <input
          type="text"
          value={otherText || ''}
          onChange={(e) => onOtherChange(e.target.value)}
          placeholder="Describe the other items (for example spare strings, adapter cable)"
          aria-label="Describe the other included items"
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${theme.colors.grey300}`,
            borderRadius: theme.radius.md,
            fontSize: '14px',
            outline: 'none'
          }}
        />
      )}
    </>
  )
}
